<template>
  <vx-card title="Account" class="mb-base">
    <!-- Avatar -->
    <div class="vx-row">
      <!-- Avatar Col -->
      <!-- <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="user_data.avatar" class="rounded w-full" />
            </div>
      </div>-->

      <!-- Information - Col 1 -->

      <div class="vx-col flex-1" id="account-info-col-1">
        <template v-for="(fName,fId) in dataStructure[0]">
          <vs-row :key="fId" class="p-2">
            <vs-col class="font-semibold" vs-type="flex" vs-w="6">{{fName[1].label }}</vs-col>

            <vs-col
              v-if="fName[1].type == 'aronSelect'"
              vs-type="flex"
              vs-w="5"
            >{{ decodeSelectValue(data[fName[0]],fName[1].data) }}</vs-col>

            <vs-col
              v-else-if="fName[1].type == 'aronMultiSelect'"
              vs-type="flex"
              vs-w="5"
            >{{ decodeMultiSelectValue(data[fName[0]]) }}</vs-col>

            <vs-col
              v-else-if="fName[1].type == 'aronCurrency'"
              vs-type="flex"
              vs-w="6"
            >{{formatCurrency(fName[1].currency, data[fName[0]])}}</vs-col>

              <vs-col v-else-if="fName[1].type == 'aronFile'" vs-type="flex" vs-w="6"> 
              <img :src="showFileOrImageHandler(data[fName[0]])" height="100px" width="100px" />
            </vs-col>

            <vs-col v-else vs-type="flex" vs-w="6">{{ data[fName[0]] }}</vs-col>
          </vs-row>
        </template>
      </div>

      <!-- /Information - Col 1 -->

      <!-- Information - Col 2 -->

      <div class="vx-col flex-1" id="account-info-col-2">
        <template v-for="(fName,fId) in dataStructure[1]">
          <vs-row :key="fId" class="p-2">
            <vs-col class="font-semibold" vs-type="flex" vs-w="7">{{fName[1].label }}</vs-col>

            <vs-col
              v-if="fName[1].type == 'aronSelect'"
              vs-type="flex"
              vs-w="5"
            >{{ decodeSelectValue(data[fName[0]],fName[1].data) }}</vs-col>

            <vs-col
              v-else-if="fName[1].type == 'aronMultiSelect'"
              vs-type="flex"
              vs-w="5"
            >{{ decodeMultiSelectValue(data[fName[0]]) }}</vs-col>

            <vs-col
              v-else-if="fName[1].type == 'aronCurrency'"
              vs-type="flex"
              vs-w="6"
            >{{formatCurrency(fName[1].currency, data[fName[0]].data)}}</vs-col>

            <vs-col v-else-if="fName[1].type == 'aronFile'" vs-type="flex" vs-w="6"> 
              <img :src="showFileOrImageHandler(data[fName[0]])" height="50px" width="auto" />
            </vs-col>

            <vs-col v-else vs-type="flex" vs-w="5">{{ data[fName[0]] }}</vs-col>
          </vs-row>
        </template>
      </div>

      <!-- /Information -    Col 2 -->
      <div class="vx-col w-full flex" id="account-manage-buttons">
        <vs-button
          v-if="showEditBtn"
          icon-pack="feather"
          icon="icon-edit"
          class="mr-4"
          @click="editData()"
        >Edit</vs-button>

        <vs-button
          v-show="showDeleteBtn"
          type="border"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          class="mr-4"
          @click="handleDelete()"
        >Delete</vs-button>
        <vs-button
          v-show="showCancelBtn"
          type="border"
          color="warning"
          icon-pack="feather"
          icon="icon-arrow-left"
          :to="{name: 'profile_home', params: { endPoint: endPoint}}"
        >Cancel</vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
import { helperMixin } from "../../../../mixin/helperMixin";
import { dialogMixin } from "../../../../mixin/dialogMixin";
import { axiosMixin } from "../../../../mixin/axiosMixin";

import axios from "@/axios.js";

import vuePdf from "../../../aron/dataViews/vuepdf";
export default {
  //     components: {
  //     vSelect
  //   },
  mixins: [helperMixin, dialogMixin, axiosMixin],

  props: {
    data: {
      type: Object,
      default: () => {},
      required: true
    },
    endPoint: {
      type: String,
      required: true
    },
    editPage: {
      type: String,
      default: ""
    },
    dataStructure: {
      type: Array,
      default: () => {},
      required: true
    },
    showDeleteBtn: { type: Boolean, default: false },
    showEditBtn: { type: Boolean, default: false },
    showCancelBtn: { type: Boolean, default: false }
  },

  data() {
    return {
      selected: ""
    };
  },

  computed: {
    baseURl() {
      return axios.defaults.baseURL;
    }
  },

  created() {
    console.log("dataStructure:", this.dataStructure);
  },

  methods: {
    showFileOrImageHandler(source) {
      console.log("source:", source);
      var filename = this.getFileExtention(source);
      console.log("filename:", filename);
      if (filename == "pdf") {
        this.showPdf = true;
        this.thePdfSource = this.baseURl + "/storage/" + source;
      } else if (
        filename == "jpeg" ||
        filename == "jpg" ||
        filename == "png" ||
        filename == "gif"
      ) {
        this.showImage = true;
        return  this.baseURl + "/storage/" + source; 
      }
    },
    editData() {
      //:to="{name: 'profile-edit', params: { endPoint: endPoint}}"

      if (this.editPage == "") {
        this.$router
          .push("/edit/" + this.endPoint + "/" + "new")
          .catch(() => {});
      } else {
        this.$router
          .push("/" + this.editPage + "/" + this.endPoint)
          .catch(() => {});
      }
    },
    formatCurrency(currency, value) {
      return this.displayCurrency(currency, value);
    },
    handleDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this?",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      this.aronDelete(this.endPoint, this.$route.params.id, "Item Deleted!")
        .then(response => {
          this.$router.push("/profile/" + this.endPoint).catch(() => {});
        })
        .catch(error => {
          console.log("in elete error: ", error);
        });
    },
    decodeSelectValue(value, options) {
      console.log("value:", value);
      console.log("options:", options);
      return this.decodeValueForSelect(options, value);
    },
    decodeMultiSelectValue(value) {
      return this.flattenJsonStringArray(value, "label");
    }
  }
};
</script>

